import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export interface User {
  _id: string;
  name?: string;
  email?: string;
  phone?: string | number;
  avatar?: string;
  firstOrderDiscount?: boolean;
  isBlocked?: boolean;
  createdAt?: string;
  updatedAt?: string;
  status?: string;
  isFirstOrder?: boolean;
  user?: {
    name?: string;
    email?: string;
    phone?: string | number;
  };
}

interface AuthState {
  user: User | null;
  accessToken: string | null;
  setUserData: (user: User, token: string) => void;
  clearAuth: () => void;
  logout: () => void;
}

// Persist user and accessToken to localStorage so the session survives page refresh
// even across cross-domain production environments (Vercel frontend + separate backend domain)
// where 3rd-party httpOnly cookies are blocked by modern browsers.
export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      setUserData: (user, accessToken) => set({ user, accessToken }),
      clearAuth: () => set({ user: null, accessToken: null }),
      logout: () => {
        import("@/lib/axios").then(({ axiosAdmin }) =>
          axiosAdmin.post("/user/auth/logout").catch(() => undefined)
        );
        set({ user: null, accessToken: null });
      },
    }),
    {
      name: "user-auth-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);